import Vue from "vue";
import VueRouter from "vue-router";
import index from "../pages/index.vue";
// import assistance from "../pages/assistance.vue";
// import punchcard from "../pages/punchcard.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "index",
        component: index,
    },
    // {
    //     path: "/assistance",
    //     name: "assistance",
    //     component: assistance,
    // },
    // {
    //     path: "/punchcard",
    //     name: "punchcard",
    //     component: punchcard,
    // },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;
